import { syncAppLocaleFromLegacy, parseRouteLangQuery } from '~/composables/useAppLocale';

/** 레거시 iframe postMessage → Nuxt SPA locale 동기화 */
export default defineNuxtPlugin(() => {
  if (!import.meta.client) return;

  window.addEventListener('message', async event => {
    const type = event?.data?.type;
    if (type !== 'LOCALE_CHANGED' && type !== 'CHANGE_LANG') {
      return;
    }

    const lang = event?.data?.lang ?? event?.data?.data?.lang;
    if (!parseRouteLangQuery(lang)) {
      return;
    }

    await syncAppLocaleFromLegacy(lang);
  });
});
